import { render, staticRenderFns } from "./relayAlertKeys.vue?vue&type=template&id=e27ef376&"
import script from "./relayAlertKeys.vue?vue&type=script&lang=ts&"
export * from "./relayAlertKeys.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports